module.exports = __webpack_public_path__ + "img/account-like.940d1394.svg";